export default "__VITE_ASSET__DNTyI6FF__"